import { getWithRetry } from '../../misc/requests.js';
import { resourceError } from '../../misc/request-errors.js';

const API_URL = process.env.VUE_APP_API_URL + '/bookings';

const expand = [
    'seminarDate',
    'seminarDate.trainers.contact',
    'seminarDate.seminar',
    'seminarDate.rooms',
];

const state = {
    booking: null,
};
const getters = {
    booking: (state) => state.booking,
};
const actions = {
    async fetchBooking({ commit }, { hash, signal }) {
        const response = await getWithRetry(`${API_URL}/${hash}/by-hash?expand=${expand.join(',')}`, signal);
        if (response.data === null) throw resourceError('RESOURCE_NOT_FOUND');
        if (!response.data?.id || !response.data.seminarDate?.seminar) throw resourceError('INVALID_RESPONSE');
        commit('setBooking', response.data);
        commit('setSeminarDate', response.data.seminarDate);
    }
};
const mutations = {
    setBooking: (state, booking) => state.booking = booking,
};

export default {
    state,
    getters,
    actions,
    mutations,
}
